import { Building2, Sparkles, UserCheck } from "lucide-react";

interface Props {
  email: string | undefined;
  onNext: () => void;
}

export function WelcomeStep({ email, onNext }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold tracking-display-tight text-copy">
          Welcome to OneShift
        </h2>
        {email && <p className="mt-1 text-sm text-copy-muted">Signed in as {email}</p>}
      </div>

      <p className="text-sm text-copy">
        Let's set up your venue so workers know who they're applying to. This takes about
        2 minutes — you'll be able to post your first shift right after.
      </p>

      <ul className="space-y-3">
        <BulletItem
          icon={<Building2 className="h-4 w-4" />}
          title="Business basics"
          desc="Name, address, and a contact phone number for confirmed workers."
        />
        <BulletItem
          icon={<Sparkles className="h-4 w-4" />}
          title="What kind of venue you are"
          desc="Restaurant, bar, catering, event venue. Helps the right workers find your shifts."
        />
        <BulletItem
          icon={<UserCheck className="h-4 w-4" />}
          title="Your logo"
          desc="Workers see this on every shift card. A real photo or logo gets way more applications than a blank avatar."
        />
      </ul>

      <div className="flex items-center justify-end border-t border-border pt-4">
        <button
          type="button"
          onClick={onNext}
          className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary-hover"
        >
          Get started
        </button>
      </div>
    </div>
  );
}

function BulletItem({
  icon,
  title,
  desc,
}: {
  icon: React.ReactNode;
  title: string;
  desc: string;
}) {
  return (
    <li className="flex items-start gap-3">
      <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-md bg-primary-light text-primary">
        {icon}
      </span>
      <div className="space-y-0.5">
        <p className="text-sm font-medium text-copy">{title}</p>
        <p className="text-xs text-copy-muted">{desc}</p>
      </div>
    </li>
  );
}
